export enum ADDONS {
    ADDITIONAL_NUMBERS = 'G2CPreDID',
}
